export interface CCTTiposTransXTipoCta {
    codigoTipoCuenta: any;
    codigoTipoTransaccion: any;
}

export class CCTTiposTransXTipoCtaFormValues {
    codigoTipoCuenta: number = 0;
    codigoTipoTransaccion: number = 0;

    constructor(CCTTiposTransXTipoCta?: CCTTiposTransXTipoCtaFormValues) {
        if (CCTTiposTransXTipoCta) {
            this.codigoTipoCuenta = CCTTiposTransXTipoCta.codigoTipoCuenta;
            this.codigoTipoTransaccion = CCTTiposTransXTipoCta.codigoTipoTransaccion;
        }

    }
}